<template>
    <div class="aboutUs">
      <Helmet>
        <title>About Us - inte-QT</title>
        <meta name="title" content="About Us - inte-QT" />
        <meta property="og:title" content="About Us - inte-QT" />
        <meta property="twitter:title" content="About Us - inte-QT" />
        <meta name="description" content="A little bit of information about who we are and what we do." />
        <meta property="og:description" content="A little bit of information about who we are and what we do." />
        <meta property="twitter:description" content="A little bit of information about who we are and what we do." />
        <link rel="canonical" href="https://www.inte-qt.com/about-us" />
        <meta property="og:url" content="https://www.inte-qt.com/about-us" />
        <meta property="twitter:url" content="https://www.inte-qt.com/about-us" />
      </Helmet>
  
      <img
        src="/images/Rgam7cI.jpg"
        alt="inte-QT team"
        class="banner-img banner-img__black"
      />
  
      <h1 class="banner-img__header text-center">About inte-QT</h1>
  
      <div class="aboutUs__box" style="text-align: justify;">
        <div class="b_read">
          <h2>Our Mission</h2>
          <p>
            "inte-QT" is derived from "integrity" and "equity," two fundamental principles that underpin our business philosophy. We believe that this new name encapsulates our dedication to honesty, fairness, and quality, which have always been at the heart of our partnership.
          </p>
  
          <h2>What We Do</h2>
          <p>
            At inte-QT, our mission is to empower Service Providers (Internet, Telco, Cloud, and SDWAN) and System Integrators with the best-in-class access service, global internet connectivity, and managed services across the globe. This name represents our dedication to providing cutting-edge technology solutions to simplify quoting processes and enhance your experience.
          </p>
  
          <h2>Our Global Presence</h2>
          <p>
            Headquartered in Madrid, Spain, we follow the best practices and certified processes with our team members experienced in Telecommunications. Our Global 24X7 Network & Security Operations Center (NSOC) is operational, where our teams manage technical solutions, project management, and global multi-layer support.
          </p>
  
          <p class="my-5">
            Our Supplier Management team has extensive experience in the Internet & Managed Service markets across the globe. We are vendor-agnostic, and our Partner Center program is designed to upgrade our partner network in every corner of the world.
          </p>
        </div>
      </div>
  
      <AboutGallery />
  
      <h2 class="center-header center-header__title mx-auto text-center">
        We Help Not One, But Many Industries
      </h2>
  
      <CarouselIndu />
      <GetInTouch />
    </div>
  </template>
  
  <script>
  import AboutGallery from '@/components/AboutGallery.vue'
  import CarouselIndu from '@/components/CarouselIndu.vue'
  import GetInTouch from '@/components/GetInTouch.vue'
  
  export default {
    name: 'AboutPage',
    components: {
      AboutGallery,
      CarouselIndu,
      GetInTouch
    },
    mounted() {
      window.scrollTo(0, 0)
    }
  }
  </script>
  
  <style scoped>


  </style>
  